import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class TextHighlightStory extends PureComponent {
  static propTypes = {
    text: PropTypes.string
  }

  render() {
    const { text } = this.props

    return (
      <div className="text-container">
        <div className="text-response">{text}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/TextHighlightStory.js